import {TripCollection} from "../Trip";
import aproape from "../../../assets/child/aproape.jpg";

const dayChildAproape: TripCollection = {
    imageSrc: aproape,
    trips: [
        {
            name: "13.1. Bran I",
            route: "Braşov – Râşnov – Bran – Braşov",
            days: [
                [
                    {
                        locationName: "Cetatea Râşnov",
                        details: "Momentan se vizitează doar grădina cetăţii"
                    },
                    {
                        locationName: "Peştera Valea Cetăţii",
                    },
                    {
                        locationName: "Castelul Bran",
                    },
                    {
                        locationName: "Muzeul Naţional Bran",
                    },
                ]
            ],
            notes: "Excursia oferă o zi plină de istorie, aventură și descoperiri captivante. Prima oprire este la Cetatea Râșnov, impresionantă fortificație medievală, unde vizitatorii pot explora zidurile și turnurile ce păstrează atmosfera epocii. Urmează Peștera Valea Cetății, un loc fascinant ce dezvăluie frumusețea naturii subterane. Traseul continuă la Castelul Bran, simbol al legendei lui Dracula și monument de referință al istoriei locale, și se încheie la Muzeul Național Bran, unde patrimoniul cultural și istoric al zonei prinde viață. Excursia combină aventura cu cunoașterea, oferind o experiență completă și memorabilă."
        },
        {
            name: "13.2. Bran II",
            route: "Braşov – Dâmbovicioara – Bran – Braşov",
            days: [
                [
                    {
                        locationName: "Peştera Dâmbovicioara",
                    },
                    {
                        locationName: "Muzeul Naţional Bran",
                    },
                    {
                        locationName: "Castelul Bran",
                    },
                ]
            ],
            notes: "Excursia propune o zi plină de aventură, istorie și descoperiri fascinante. Prima oprire este la Peștera Dâmbovicioara, un loc spectaculos care dezvăluie frumusețea naturii subterane și forme impresionante de relief. Traseul continuă la Castelul Bran, simbol al legendei lui Dracula și monument reprezentativ al istoriei locale, urmat de Muzeul Național Bran, unde vizitatorii pot explora colecții care păstrează patrimoniul cultural și istoric al zonei. Excursia combină aventura cu cunoașterea, oferind o experiență memorabilă și completă."
        },
        {
            name: "13.3. Râșnov",
            route: "Braşov – Râşnov – Braşov",
            days: [
                [
                    {
                        locationName: "Cetatea Râşnov",
                    },
                    {
                        locationName: "Peştera Valea Cetăţii",
                    },
                    {
                        locationName: "Dino Parc",
                    },
                ]
            ],
            notes: "Excursia oferă o zi plină de aventură, istorie și descoperiri captivante pentru elevi. Prima oprire este la Cetatea Râșnov, impresionantă fortificație medievală, unde participanții pot explora zidurile și turnurile ce păstrează atmosfera epocii. Urmează Peștera Valea Cetății, un spațiu subteran fascinant, care dezvăluie frumusețea naturii și forme spectaculoase de relief. Excursia se încheie la Dino Parc, un loc interactiv și educativ, unde recreațiile impresionante ale dinozaurilor stimulează curiozitatea și oferă momente de distracție memorabile pentru toți elevii."
        },
        {
            name: "13.4. Râşnov – o zi la Dino Parc",
            route: "",
            days: [
                [
                    {
                        locationName: "Dino Parc",
                        details: "Timp liber pentru recreere şi divertisment"
                    },
                ]
            ],
            notes: ""
        },
    ]
}

export default dayChildAproape;